import React from "react";
import Paper from "../../common/Paper";
import TabPanel from "../../common/TabPanel";
import Tabs from "../../common/Tabs";
import { getEnrollees } from "../../../store/enrollee";
import { useSelector } from "react-redux";
import styles from "./index.module.css";
import { getFormatedDate } from "../../../utils/constants";

const DrugRefillRequestDetails = ({ details }) => {
  const enrollees = useSelector(getEnrollees);
  const enrollee = enrollees.data ? enrollees.data.enrollee_details : {};

  console.log(details);
  if (!details) return null;
  return (
    <Paper className="mb-5">
      <Tabs
        activeTab={"Request Details"}
        tabData={["Request Details", "", "", "", ""]}
        tabIndex={0}
        onTabChange={(index) => console.log(index)}
      />

      <div className={styles["tab-panel-body"]}>
        <TabPanel value={0} index={0}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Enrollee ID</th>
                <th>Enrollee Name</th>
                <th>Enrollee email</th>
                <th>Phone Number</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>{enrollee.enrollee_id}</td>
                <td>{enrollee.name}</td>
                <td style={{ textTransform: "none" }}>{enrollee.email}</td>
                <td style={{ textTransform: "none" }}>{enrollee?.phone_number}</td>
              </tr>
            </tbody>

            <thead>
              <tr className={styles["table-row"]}>
                <th>Medication Name</th>
                <th>Reason for drug?</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr className={styles["table-row"]}>
                <td>{details.drug_name}</td>
                <td>{details.reason}</td>
                <td>{details.status}</td>
              </tr>
            </tbody>
            <thead>
              <tr className={styles["table-row"]}>
                <th>Date Requested</th>
              </tr>
            </thead>
            <tbody>
              <tr className={styles["table-row"]}>
                <td>{getFormatedDate(details.created_at)}</td>
              </tr>
            </tbody>
            <thead>
              <tr className={styles["table-row"]}>
                <th>Images</th>
              </tr>
            </thead>
            <tbody>
              <tr className={styles["table-row"]}>

                <td>
                  {
                    details?.image ?  <img src={details?.image} width={50} height={50} /> : 'none'
                  }
                  <div>
                    <a href={details?.image} style={{backgroundColor:'#fdfdfd',textDecoration:'underline'}}>view</a>
                  </div>
                 
                </td>
              </tr>
            </tbody>
          </table>
        </TabPanel>
      </div>
    </Paper>
  );
};

export default DrugRefillRequestDetails;
